<template>
    <v-container>
        <v-card class="mx-auto">
            <v-toolbar flat color="secondary" dark>
                <v-toolbar-title>{{ this.$route.meta.title }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                 <v-form
                    ref="form"
                    v-on:submit.prevent="store()"
                    lazy-validation>
                    <v-row>
                            <v-col cols="12">
                            <v-text-field
                            v-model="code"
                            :counter="2"
                            :rules="this.rules.code"
                            label="Code"
                            required
                            v-focus
                            maxlength="2"
                            ></v-text-field>
                            </v-col>

                            <v-col cols="12">
                            <v-text-field
                            v-model="name"
                            :counter="50"
                            label="Name"
                            required
                            :rules="this.rules.nama"
                            maxlength="50"
                            ></v-text-field>
                            </v-col>


                    </v-row>
                    <v-row>
                        <v-col>
                            <v-card-actions>
                                <v-btn @click="btnBack"
                                color="grey lighten-5" type="button"><v-icon left>{{icon.back}}</v-icon>Back</v-btn>

                                <v-btn 
                                :disabled="loading"
                                color="primary" type="submit" class="float-right"><v-icon left>{{icon.save}}</v-icon>Simpan</v-btn>
                            </v-card-actions>
                        </v-col>
                    </v-row>
                 </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
/* eslint-disable */
    import rules from "@/plugins/validation_rules.js";
    let context;
    export default{
        name: "locales.add",
        data:()=>{
            return{
                edit:false,
                loading:false,
                show:false,
                rules:rules,
                icon:{
                    save:"mdi-check-bold",
                    back:"mdi-arrow-left"
                },
                name:"",
                code:"",
            }
        },
        methods:{
            btnBack () {
                this.$router.go(-1);
            },
            store:async ()=>{
                if(context.$refs.form.validate()){
                    context.loading=true;
                    let payload={
                        name:context.name,
                        code:context.code,
                    };

                    let uri;
                    let success_text;
                    
                    if(!context.edit){
                        await context.$http
                        .post(context.$route.meta.parent+'/store',payload)
                        .then(response=>{
                            if(response.status===200){
                                context.$notify({
                                    group:"success",
                                    title:"Success Notification",
                                    text:"Berhasil menambahkan "+payload.name+" ke database"
                                })
                                context.$refs.form.reset();
                            }
                        })
                        .catch(err=>{
                            context.$notify({
                                    group:"error",
                                    title:"Error Notification",
                                    text:"Terjadi kesalahan pada client"
                            })
                        });
                    }else{
                        payload.id=context.$route.params.id;
                        await context.$http
                        .patch(context.$route.meta.parent+'/update',payload)
                        .then(response=>{
                            if(response.status===200){
                                context.$notify({
                                    group:"success",
                                    title:"Success Notification",
                                    text:"Berhasil merubah "+payload.name
                                })
                            }
                        })
                        .catch(err=>{
                            context.$notify({
                                    group:"error",
                                    title:"Error Notification",
                                    text:"Terjadi kesalahan pada client"
                            })
                        });
                    }
                    
                    context.loading=false;
                }
            },

        },
        async mounted(){
            context=this;
            if(context.$route.name===context.$route.meta.parent+".edit"){
                context.edit=true;
                await context.$http
                .get(context.$route.meta.parent+'/get?id='+context.$route.params.id)
                .then(response=>{
                    let user=response.data.data;
                    if(user!=null){
                        context.name=user.name;
                        context.code=user.code;
                    }else{
                        context.$router.push("/"+context.$route.meta.parent);
                    }
                })
                .catch(err=>{

                })
            }
        }
    }
</script>